exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._33fON{text-align:center;position:absolute;width:100%;cursor:pointer;color:#000;z-index:-1}@media (min-width:768px){._33fON{top:50%}}", ""]);

// exports
exports.locals = {
	"landingText": "_33fON"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--1-rules-2!./node_modules/postcss-loader/lib??ref--1-rules-3!./src/routes/landing/Landing.css
// module id = 1278
// module chunks = 17